<template>
  <div class="board-list-dnd-container-drop-zone">
    <div class="board-list" :style="{ height: isDraggingCard ? '100%' : 'auto'}">
      <div class="board-list-title-container d-flex flex-row pr-0">
        <span class="title flex-fill font-weight-bold">Архив</span>

        <span class="board-list-cards-counter">{{ cards.length }}</span>
      </div>

      <div class="board-list-scroll-container">
        <Container
          group-name="lists"
          :get-child-payload="getChildPayload"
          @drag-start="onDragStart($event)"
          @drop="onDrop({obj: null, items: cards, archive: true}, $event)"
          :animation-duration="200"
          :style="{ minHeight: 0, height: 'auto'}"
          :drop-placeholder="dropPlaceholderOptions"
          drag-class="card-ghost"
          drop-class="card-ghost-drop"
        >
          <Draggable class="cards-draggable-wrapper" v-for="card in cards" :key="card.id">
            <Card :card="card"></Card>
          </Draggable>
        </Container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SmoothDndHelpers from "@/common/smoothDndHelpers";

import Card from "./Card.vue";
import cache from "../../store/cache";

export default {
  name: "History",
  props: ["board"],
  components: { Card },
  computed: {
    ...mapGetters(["isMobileDevice", "events", "isDraggingCard"]),
    cards() {
      if (!this.board) {
        return [];
      }

      return this.board.archive.cards;
    },
    dropPlaceholderOptions() {
      return {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true
      };
    }
  },
  data() {
    return {
      smoothDndHelpers: new SmoothDndHelpers(this.$order)
    };
  },
  methods: {
    getChildPayload(index) {
      return {
        index: index,
        item: this.cards[index],
        items: this.cards,
        obj: null,
        archive: true
      };
    },
    onDragStart(event) {
      this.smoothDndHelpers.onDragStart(event);
    },
    onContainerDrop(dest, event) {
      this.smoothDndHelpers.onContainerDrop(dest, event);
    },
    onDrop(dest, event) {
      this.smoothDndHelpers.onDrop(dest, event);
    }
  },
  mounted() {
    const _this = this;
    this.smoothDndHelpers.dragStartedCallbacks.push(() => {
      _this.$store.commit("DRAG_CARD", true);
    });

    this.smoothDndHelpers.onDropGuards.push(() => {
      return !_this.isDraggingCard;
    });

    this.smoothDndHelpers.beforeDropCallbacks.push(() => {
      _this.$store.commit("DRAG_CARD", false);
    });

    this.smoothDndHelpers.toArchiveDropCallbacks.push(item => {
      _this.$store.dispatch("cards/archive", item);
    });

    this.smoothDndHelpers.droppedCallbacks.push(payload => {
      _this.$store.dispatch("cards/move", {
        list: payload.obj ? payload.obj : cache.lists.byId(payload.item.list_id),
        card: payload.item,
        order: payload.order
      });
    });
  }
};
</script>


